import {
  BrokenInAppBrowser,
  cannotEscape,
  detectBrokenIosInAppBrowser,
} from "./detect";
import { isBlockedDestination } from "./escapeAttempts";

/**
 * True where no escape can work, so the only thing left is to tell the visitor
 * to leave the webview themselves. False in the webviews an escape works in.
 *
 * Gated on the destination like everything else here: a link these webviews
 * open perfectly well has nothing to warn about.
 */
export function mustOpenInBrowser(
  browser: BrokenInAppBrowser | null,
  destination: string | null | undefined
): boolean {
  if (!browser || !destination) return false;
  return cannotEscape(browser) && isBlockedDestination(destination);
}

/**
 * mustOpenInBrowser for the server, from the request. App Preview and the iOS
 * copy-link page only lead to the App Store, so where this is true the page
 * shows neither: its visitors get the redirect page, which tells them to open
 * the link in their browser, where both show as usual.
 */
export function requestMustOpenInBrowser({
  userAgent,
  isBotRequest,
  iosDestination,
}: {
  userAgent: string;
  isBotRequest: boolean;
  iosDestination: string | null;
}): boolean {
  if (isBotRequest) return false;
  return mustOpenInBrowser(
    detectBrokenIosInAppBrowser(userAgent),
    iosDestination
  );
}
